export const OAUTH_RECTIFIER_ROUTE = '/oauth-redirect/';
